
//export const cmsEntryPoint = "google.analytics";
export const cmsEntryPoint = "products.products";
export const cmsName = "HORUS";